export default __webpack_public_path__ + "static/media/6-myinfo-storage.ff9bec42.svg";